import 'core-js/es6/map';
import 'core-js/es6/set';

import 'raf/polyfill';

require('array.prototype.find').shim();
import 'jspolyfill-array.prototype.findIndex';
import 'string.prototype.startswith';
import 'string.prototype.repeat';
import 'es6-math';

// Number.isNaN() polyfill
if (typeof Number.isNaN !== 'function') {
  /* tslint:disable-next-line */
  Number.isNaN = function (value) {
    return value !== null // Number(null) => 0
      && (value !== value // NaN != NaN
        || +value !== value // Number(falsy) => 0 && falsy == 0...
      );
  };
}

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';

import 'normalize.css';

import 'react-table/react-table.css';

import './index.scss';

import { BrowserRouter as Router, Route, Redirect, Switch } from 'react-router-dom';

import Splash from './views/Splash';
import Toast from 'components/Toast';
import Modal, { BadRequestHandler } from 'components/Modal';
import Tooltip from 'components/Tooltip';
import App from './App';
import { UserService } from 'services/ApiService';
import { RouteProps } from 'react-router';
import { APP_PATH } from 'helpers/routes';

const AuthRoute = ({ component, ...rest }: RouteProps) => (
  <Route 
    {...rest}
    render={(props) => (
      UserService.checkAuth()
        ? React.createElement(component!!, props)
        : <Redirect to={`/?redirect=${location.pathname}`} />
    )} 
  />
);

class AppRouter extends React.Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/" exact={true} component={Splash} />
          <AuthRoute path={APP_PATH} component={App} />
          <Route>
            <Redirect to="/" />
          </Route>
        </Switch>
      </Router>
    );
  }
}

ReactDOM.render(<><AppRouter /><Modal.Element /><Toast /><Tooltip.Element /><BadRequestHandler /></>,
  document.getElementById('root') as HTMLElement
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx